import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchProjects } from '../api/projects';
import { getProjects } from './projects';

const useProjects = () => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage?.startsWith('zh') ? 'zh' : 'en';
  const [projects, setProjects] = useState(() => getProjects(language));

  useEffect(() => {
    let active = true;
    setProjects(getProjects(language));
    fetchProjects(language)
      .then((items) => {
        if (active && Array.isArray(items)) setProjects(items);
      })
      .catch(() => {
        // Keep the bundled project so the public portfolio remains available during a backend deployment.
      });
    return () => { active = false; };
  }, [language]);

  return projects;
};

export default useProjects;
